import React from 'react'
export const RoomSetup = (props) => {
  const { setInputRoomId, createRoom, joinRoom, inputRoomId } = props
  return (
    <div className='room-setup'>
      <h2>Join a Screen Sharing Room</h2>
      <div className='room-controls'>
        <input
          type='text'
          placeholder='Enter room ID or leave empty for random'
          value={inputRoomId}
          onChange={(e) => setInputRoomId(e.target.value)}
          className='room-input'
        />
        <div className='room-buttons'>
          <button onClick={createRoom} className='btn btn-primary'>
            Create Room
          </button>
          <button onClick={joinRoom} className='btn btn-secondary'>
            Join Room
          </button>
        </div>
      </div>
    </div>
  );
};
